//menu mobile

document.querySelector(".menu").addEventListener("click", function () {
  document.querySelector(".subNavAndMobile").style.left = "0%";
  document.querySelector("body").style.overflow = "hidden";
});

document.querySelector(".closeMenu").addEventListener("click", function () {
  document.querySelector(".subNavAndMobile").style.left = "100%";
  document.querySelector("body").style.overflow = "initial";
});

// storyboard

if (document.querySelector(".storyBoard")) {
  const years = document.querySelector(".yearList .overTitle");
  const images = document.querySelectorAll(".imgStoryWrap img");
  const storyYear = document.querySelector(".storyContent .year");
  const storyText = document.querySelectorAll(".storyContent p");
  const storyTitle = document.querySelectorAll(".storyTitle");

  years.addEventListener("click", (e) => {
    const year = e.target.closest("li");
    if (!year) return;
    storyYear.innerText = +year.innerText;
    year.style.textDecoration = "underline";
    images.forEach((image, i) => {
      if (image.dataset.year !== year.innerText) {
        image.style.display = "none";
        storyText.item(i).style.display = "none";
        storyTitle.item(i).style.display = "none";
        years.children.item(i).style.textDecoration = "none";
      } else {
        image.style.display = "block";
        storyText.item(i).style.display = "block";
        storyTitle.item(i).style.display = "block";
      }
    });
  });
}

// references

if (document.querySelector(".references")) {
  let indexReference = 1;
  const leftArrow = document.querySelector(".references .slideArrows .left");
  const rightArrow = document.querySelector(".references .slideArrows .right");
  const references = document.querySelectorAll(".references .twoColumnGrid");

  leftArrow.addEventListener("click", () => {
    if (Array.from(leftArrow.classList).includes("disabled")) {
      return;
    }
    indexReference = indexReference - 1;

    references.forEach((reference, i) => {
      if (+reference.dataset.reference !== indexReference) {
        //reference.style.display = "none";
        reference.style.position = "absolute";
        reference.style.left = "-100%";
      } else {
        //reference.style.display = "grid";
        reference.style.position = "static";
      }
    });

    if (indexReference === 1) {
      leftArrow.classList.add("disabled");
    } else {
      rightArrow.classList.remove("disabled");
    }
  });

  rightArrow.addEventListener("click", () => {
    if (Array.from(rightArrow.classList).includes("disabled")) {
      return;
    }
    indexReference = indexReference + 1;

    references.forEach((reference, i) => {
      if (+reference.dataset.reference !== indexReference) {
        //reference.style.display = "none";
        reference.style.position = "absolute";
        reference.style.left = "-100%";
      } else {
        //reference.style.display = "grid";
        reference.style.position = "static";
      }
    });

    if (indexReference < 3) {
      leftArrow.classList.remove("disabled");
    } else {
      rightArrow.classList.add("disabled");
    }
  });
}

// Slider

function lazySlide(images) {
  let loaded = [];
  return function loadImages(s) {
    const slideIdx = s.track.details.rel;
    loaded[slideIdx] = true;

    s.slides.forEach((element, idx) => {
      if (loaded[idx]) {
        element.setAttribute("src", images[idx]);
      } else {
        element.setAttribute("src", ""); //Spinner o Placeholder qui
      }
    });
  };
}

function createKeenSlider(id, settings = {}) {
  const slider = new KeenSlider("#" + id, settings);
  let leftArrow, rightArrow, dotsArr, prevIndex;

  //arrows

  if (document.querySelector("." + id + ".slideArrows .left")) {
    leftArrow = document.querySelector("." + id + ".slideArrows .left");
    leftArrow.addEventListener("click", () => {
      if (Array.from(leftArrow.classList).includes("disabled")) {
        return;
      } else {
        slider.moveToIdx(slider.track.details.rel - 1);
      }
    });
  }

  if (document.querySelector("." + id + ".slideArrows .right")) {
    rightArrow = document.querySelector("." + id + ".slideArrows .right");
    rightArrow.addEventListener("click", () => {
      if (Array.from(rightArrow.classList).includes("disabled")) {
        return;
      } else {
        slider.moveToIdx(slider.track.details.rel + 1);
      }
    });
  }

  //dots
  if (document.querySelector("." + id + ".dots")) {
    const dots = document.querySelector("." + id + ".dots");
    dotsArr = Array.from(dots.children);

    dotsArr.forEach((el, i) => {
      el.setAttribute("data-slide", i);
    });

    dots.addEventListener("click", (e) => {
      const activeDot = e.target.closest(".dot");
      slider.moveToIdx(+activeDot.dataset.slide);
      dotsArr.forEach((el, i) => {
        if (i === +activeDot.dataset.slide) {
          el.classList.add("dot--active");
        } else {
          el.classList.remove("dot--active");
        }
      });
    });
  }

  slider.on("slideChanged", () => {
    dotsArr &&
      dotsArr.forEach((el, i) => {
        if (+el.dataset.slide === slider.track.details.rel) {
          el.classList.add("dot--active");
        } else {
          el.classList.remove("dot--active");
        }
      });
    if (leftArrow) {
      if (slider.track.details.rel === 0) {
        leftArrow.classList.add("disabled");
      } else {
        leftArrow.classList.remove("disabled");
      }
    }
    if (rightArrow) {
      if (slider.track.details.rel === slider.track.details.maxIdx) {
        rightArrow.classList.add("disabled");
      } else {
        rightArrow.classList.remove("disabled");
      }
    }
  });
}
